<template>
  <div>
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
        class="scrollableBar"
        :style="{
          overflow: 'auto',
          flex: '0 0 152px',
          minWidth: '152px',
          maxWidth: '152px',
          width: '152px',
          height: '100vh',
          backgroundColor: '#5F60D3'
        }"
        v-model="collapsed"
        :trigger="null"
        collapsible
      >
        <!-- old logo: -->
        <!-- <div class="logo" :style="{width: collapsed? '80px': '200px'}">
                    <div class="logo_inner ZHIHUISHU_QZMD" @click="$router.push('/');">
                        <img :src="collapsed? '//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/d82cf0e15008449d99e3ec273f50f5c5.png': '//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/d4a212430c734f5d894f332447f2d224.png'" alt="智慧树">
                    </div>  
                </div> -->
        <div class="new_logo">
          <img
            src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/90d733a7b0494e78a1cc6382dc9840d1.png"
            alt="同步课堂网"
            @click="$router.push('/')"
          />
        </div>
        <a-menu
          :style="{ backgroundColor: '#5F60D3' }"
          theme="dark"
          mode="inline"
          v-if="treeExpandTree && treeExpandTree.length"
          :selected-keys="defaultSelectedKeys"
          :default-open-keys="defaultOpenKeys"
        >
          <template v-for="item in treeExpandTree">
            <template v-if="item.childMenu && item.childMenu.length">
              <a-sub-menu :key="item.id">
                <template slot="title">
                  <div class="a_sub_menu_title_icon_for_img">
                    <img :src="item.iconImage" :alt="item.menuName" />
                  </div>
                  <span>{{ item.menuName }}</span>
                </template>
                <template v-for="child in item.childMenu">
                  <template v-if="child.childMenu && child.childMenu.length">
                    <a-sub-menu :key="child.linkUrl">
                      <template slot="title">
                        <span class="anticon">
                          <i :class="['iconfont', child.icon]"></i>
                        </span>
                        <span>{{ child.menuName }}</span>
                      </template>
                      <template v-for="littleChild in child.childMenu">
                        <a-menu-item class="ZHIHUISHU_QZMD" :key="littleChild.linkUrl" @click="menuItemClick">
                          <span>{{ littleChild.menuName }}</span>
                        </a-menu-item>
                      </template>
                    </a-sub-menu>
                  </template>
                  <a-menu-item class="ZHIHUISHU_QZMD" :key="child.linkUrl" @click="menuItemClick" v-else>
                    <span>{{ child.menuName }}</span>
                  </a-menu-item>
                </template>
              </a-sub-menu>
            </template>
            <template v-else>
              <a-menu-item class="ZHIHUISHU_QZMD" :key="item.linkUrl" @click="menuItemClick">
                <!-- <span class="anticon">
                  <i :class="['iconfont', item.icon]"></i>
                </span> -->
                <div class="a_sub_menu_title_icon_for_img">
                  <img :src="item.iconImage" :alt="item.menuName" />
                </div>
                <span :style="{ color: '#FFF' }">{{ item.menuName }}</span>
              </a-menu-item>
            </template>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0; height: 56px; z-index: 1">
          <div class="layout_header_container">
            <!-- 改造，以下暂时去除： -->
            <!-- <div class="operation_for_close_or_open">
                            <a-icon class="trigger ZHIHUISHU_QZMD" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="() => (collapsed = !collapsed)"/>
                        </div>
                        <div :class="['breadcrumb_container', breadcrumbMoveClassNameShow? 'breadcrumb_move_class_name': '']">
                            <a-breadcrumb>
                                <a-breadcrumb-item v-for="item in breadcrumbList" :key="item">
                                    <span>{{item}}</span>
                                </a-breadcrumb-item>
                            </a-breadcrumb>
                        </div> -->
            <!-- 改为： -->
            <div class="welcome_text">欢迎来到同步课堂网管理中心</div>
            <div class="header_right_module">
              <!-- 机构名称： -->
              <div class="org_name_from_some_max_for_three">
                {{ orgNameMaxForThree }}
              </div>
              <div class="messsage_icon">
                <img
                  src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/0f4a40eb51ba4c88be010a6f257f9f53.png"
                  alt="message"
                />
              </div>
              <div class="popover_container">
                <!-- old: -->
                <!-- <a-popover :title="(userInfo.name ? userInfo.name : '- -') + '（' + (userInfo.schoolName ? userInfo.schoolName : '- -') + '）'" trigger="hover"> -->
                <!-- now: -->
                <a-popover trigger="hover">
                  <template slot="content">
                    <div class="user_operation_list">
                      <div class="user_operation_item_first">
                        <div class="user_operation_item_icon">
                          <img src="../assets/img/operationOverview/icon_gerenzhongxin_16@2x.png" />
                        </div>
                        <div class="user_operation_item_title">
                          {{
                            (userInfo.name ? userInfo.name : '- -') +
                            '（' +
                            (userInfo.schoolName ? userInfo.schoolName : '- -') +
                            '）'
                          }}
                        </div>
                      </div>
                      <div
                        v-for="item in userOperationList"
                        :key="item.title"
                        class="user_operation_item ZHIHUISHU_QZMD"
                        @click="userOperationItemClick(item)"
                      >
                        <!-- old: -->
                        <!-- <a-icon :type="item.icon" />
                        <span class="m_l5">{{ item.title }}</span> -->
                        <!-- now: -->
                        <div class="user_operation_item_icon">
                          <img :src="item.iconImg" />
                        </div>
                        <div class="user_operation_item_title">
                          {{ item.title }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="operation_of_user_container">
                    <div class="operation_of_user_container_inner_img">
                      <img :src="userInfo.schoolImg ? userInfo.schoolImg : userInfo.userImg" alt="头像" />
                    </div>
                    <!-- <div class="operation_of_user_container_inner_text">
                      {{ userInfo.name }}
                    </div> -->
                    <div class="operation_of_user_container_inner_icon">
                      <img
                        src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/c4bdbda9d3934b8283cf769943d0866a.png"
                        alt="operation"
                      />
                    </div>
                  </div>
                </a-popover>
              </div>
            </div>
          </div>
        </a-layout-header>
        <a-layout-content :style="{ padding: '20px', overflowX: 'hidden' }">
          <transition name="commonpage">
            <router-view v-if="!$route.meta.keepAlive" />
          </transition>
          <transition name="commonpage">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
          </transition>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <!-- choose org: -->
    <my-dialog
      @hideMask="hideMask"
      :dialogFlag="dialogFlag"
      width="852px"
      p_lr="32px 36px 16px"
      :clickMaskForHide="true"
    >
      <div class="switching_mechanism">
        <div class="lists">
          <!-- 省份列表 -->
          <div class="list_item">
            <div class="list_header">
              <a-checkbox
                :checked="provinceIsAllSelectStatus"
                :indeterminate="provinceIsSomeSelect"
                @change="provinceIsAllSelect"
              >
                省份
              </a-checkbox>
              <span>{{ provinceSelectList.length || 0 }}/{{ provinceList.length || 0 }}</span>
            </div>
            <div class="list_search">
              <a-input placeholder="请输入省份" v-model="provinceSubmit" @pressEnter="searchProvinceList">
                <template #prefix>
                  <span @click="searchProvinceList">
                    <img src="../assets/img/search.png" alt="" />
                  </span>
                </template>
              </a-input>
            </div>
            <div class="item_body">
              <div v-for="item in provinceList" :key="item.provinceId">
                <a-checkbox
                  :checked="provinceSelectList.includes(item.provinceId)"
                  :disabled="item.schoolCount == 0"
                  @change="(e) => selectProvince(e, item)"
                >
                  {{ item.provinceName }}
                </a-checkbox>
              </div>
            </div>
          </div>
          <!-- 机构学校列表 -->
          <div class="list_item" style="margin-left: 13px">
            <div class="list_header">
              <a-checkbox
                :checked="schoolIsAllSelectStatus"
                :indeterminate="schoolIsSomeSelect"
                @change="schoolIsAllSelect"
              >
                机构
              </a-checkbox>
              <span>{{ schoolSelectList.length || 0 }}/{{ schoolList.length || 0 }}</span>
            </div>
            <div class="list_search">
              <a-input placeholder="请输入学校名" v-model="schoolSubmit" @pressEnter="searchSchoolList">
                <template #prefix>
                  <span @click="searchSchoolList"><img src="../assets/img/search.png" alt="" /></span>
                </template>
              </a-input>
            </div>
            <div class="item_body">
              <div v-for="item in schoolList" :key="item.id">
                <a-checkbox :checked="schoolSelectList.includes(item.id)" @change="(e) => selectSchool(e, item)">
                  {{ item.schoolName }}
                </a-checkbox>
              </div>
            </div>
          </div>
          <div class="right_arrow">
            <img style="height: 24px; width: 24px; border-radius: 8px" src="../assets/img/right-arrow.png" alt="" />
          </div>
          <!-- 选中机构列表 -->
          <div class="list_item" style="margin-left: 13px">
            <div class="list_header">
              <span>选中机构</span>
              <span v-show="schoolSubmitSelf.length == 0">{{ currentSelectSchoolList.length || 0 }}</span>
              <span v-show="schoolSubmitSelf.length != 0">{{ currentSelectSchoolListBySelf.length || 0 }}</span>
            </div>
            <div class="list_search">
              <a-input
                placeholder="请输入学校名"
                v-model="schoolSubmitSelf"
                @change="searchSchoolListBySelf"
                @pressEnter="searchSchoolListBySelf"
              >
                <template #prefix>
                  <span @click="searchSchoolListBySelf"><img src="../assets/img/search.png" alt="" /></span>
                </template>
              </a-input>
            </div>
            <div class="item_body select_item_body" v-show="schoolSubmitSelf.length == 0">
              <div v-for="item in currentSelectSchoolList" :key="item.id">
                <span>{{ item.province }} / {{ item.schoolName }}</span>
                <img @click="deleteSchoolById(item.id)" src="../assets/img/ashcan.png" alt="" />
              </div>
            </div>
            <div class="item_body select_item_body" v-show="schoolSubmitSelf.length != 0">
              <div v-for="item in currentSelectSchoolListBySelf" :key="item.id">
                <span>{{ item.province }} / {{ item.schoolName }}</span>
                <img @click="deleteSchoolById(item.id)" src="../assets/img/ashcan.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_btn">
          <a-button @click="operationForConfirm">确定切换</a-button>
        </div>
      </div>
    </my-dialog>
  </div>
</template>

<script>
// import menuTree from '../utils/menutree'
import { mapMutations } from 'vuex'
import { findItemForTree } from '../utils/tool'
const mechanismColumns = [
  {
    title: '机构标识',
    dataIndex: 'schoolImg',
    scopedSlots: { customRender: 'schoolImg' }
  },
  {
    title: '机构名称',
    dataIndex: 'schoolName'
  }
]

export default {
  watch: {
    $route: {
      handler: function (newval, oldval) {
        let { title } = newval.meta
        this.breadcrumbList = (title || '').split('-')
        this.breadcrumbMoveClassNameShow = false
        setTimeout(() => {
          this.breadcrumbMoveClassNameShow = true
        }, 0)
        // 20220510 add start:
        let { name: nameNew } = newval || {}
        this.defaultSelectedKeys = nameNew ? [nameNew] : []
        // ...
        if (nameNew == 'ActiveListDetail') {
          this.defaultSelectedKeys = ['ActiveList']
        } else if (nameNew == 'CourseListDetail') {
          this.defaultSelectedKeys = ['CourseList']
        }
        // 20220510 end
      },
      immediate: true
    }
  },
  components: {
    'my-dialog': () => import('../components/my_dialog')
  },
  data() {
    return {
      collapsed: false,
      menuTree: [],
      userInfo: {},
      userOperationList: [
        {
          icon: 'swap',
          title: '切换机构',
          operationType: 0,
          iconImg: require('../assets/img/operationOverview/icon_qiehuan_16@2x.png')
        },
        {
          icon: 'poweroff',
          title: '退出登录',
          operationType: 1,
          iconImg: require('../assets/img/operationOverview/icon_tuichu_16@2x.png')
        }
      ],
      breadcrumbList: [],
      breadcrumbMoveClassNameShow: true,
      // menu:
      treeExpandTree: [],
      defaultSelectedKeys: [],
      defaultOpenKeys: [],
      adminUserSchoolList: [],
      dialogFlag: false,
      mechanismColumns,
      selectedRowKeys: [],
      currentSelectSchoolList: [], // 已经选中学校列表
      currentSelectSchoolListBySelf: [], // 前端筛选选中学校列表
      adminUserSchoolList: [],
      provinceList: [], // 省份列表
      provinceSelectList: [], // 选中省份列表
      provinceCanSelectList: [], // 可选省份列表
      provinceIsAllSelectStatus: false,
      provinceIsSomeSelect: false,
      provinceSubmit: '', // 搜索省份名字
      schoolSubmit: '', // 搜索学校名字
      schoolSubmitSelf: '', // 前端搜索学校名字 字段
      schoolList: [], // 学校机构列表
      schoolSelectList: [], // 选中学校列表
      schoolIsSomeSelect: false,
      schoolIsAllSelectStatus: false,
      checkedSchoolList: [] // 接口返回的选中学校列表
    }
  },
  computed: {
    orgNameMaxForThree: function () {
      let resArr = JSON.parse(JSON.stringify(this.checkedSchoolList))
      let resStr = ''
      const len = this.checkedSchoolList.length
      if (len > 3) {
        resArr = resArr.slice(0, 3)
        resStr = '等' + len + '所学校'
      }
      return `${resArr.map((item) => item.schoolName).join('、')}${resStr}`
    }
  },
  async created() {
    await this.getMenuTree()
    this.getUserInfo()
    let { name } = this.$route
    this.defaultSelectedKeys = name ? [name] : []
    // 新增需求：默认展开所有的菜单：
    const getItemForHaveSubsOfKeysList = (tree) => {
      let resArr = []
      const getItemForHaveSubs = (tree) => {
        tree.forEach((item) => {
          if (item.childMenu && item.childMenu.length) {
            if (item.linkUrl && item.linkUrl.length) {
              resArr.push(item.linkUrl)
            } else {
              resArr.push(item.id)
            }
            getItemForHaveSubs(item.childMenu)
          }
        })
      }
      getItemForHaveSubs(tree)
      return resArr
    }
    this.defaultOpenKeys = getItemForHaveSubsOfKeysList(this.menuTree)
    // 为了使菜单能够默认展开，并且点击父级可以自动展开收起
    this.treeExpandTree = JSON.parse(JSON.stringify(this.menuTree))
    let schoolRes = await this.$http.getSelectSchoolList()
    if (schoolRes.rt.resultStatus == -1 || schoolRes.code != 200) {
      return this.$message.error(schoolRes.rt.resultMessage || '获取学校数据失败!')
    }
    this.checkedSchoolList = schoolRes.rt || []
  },
  methods: {
    ...mapMutations('userInfo', {
      Mutation_REMOVE_TOKEN: 'Mutation_REMOVE_TOKEN',
      Mutation_SET_TOKEN: 'Mutation_SET_TOKEN',
      SetUserInfo: 'SetUserInfo'
    }),
    async getMenuTree() {
      const res = await this.$http.getMenuTree()
      if (res.code == 200) this.menuTree = res.rt || []

      // TODO:
      // this.menuTree = [
      //   ...this.menuTree,
      //   {
      //     childMenu: [
      //       {
      //         childMenu: [],
      //         icon: '',
      //         iconImage: '',
      //         id: 'userManagement',
      //         linkUrl: 'UserManagement',
      //         menuName: '用户管理'
      //       },
      //       {
      //         childMenu: [],
      //         icon: '',
      //         iconImage: '',
      //         id: 'administratorConfiguration',
      //         linkUrl: 'AdministratorConfiguration',
      //         menuName: '管理员配置'
      //       },
      //       {
      //         childMenu: [],
      //         icon: '',
      //         iconImage: '',
      //         id: 'teachingAssistantManagement',
      //         linkUrl: 'TeachingAssistantManagement',
      //         menuName: '助教管理'
      //       }
      //     ],
      //     icon: '',
      //     iconImage: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202401/61b75d48a20c4f0c87cc22d601b22503.png',
      //     id: 'personnelManagement',
      //     linkUrl: '',
      //     menuName: '人员管理'
      //   }
      // ]

      // this.menuTree[4].childMenu.push({
      //   childMenu: [],
      //   icon: '',
      //   iconImage: '',
      //   id: 'test-organizationalManagement',
      //   linkUrl: 'OrganizationalManagement',
      //   menuName: '机构管理'
      // })

      // TODO: 开发阶段先手动拼接，后续需要接口按此格式返回
      // if(res.code == 200) this.menuTree = [
      //   ...[
      //     {
      //       childMenu: [
      //         {
      //           childMenu: [],
      //           icon: '',
      //           iconImage: '',
      //           id: 'test-onLineInspectionTour',
      //           linkUrl: 'OnLineInspectionTour',
      //           menuName: '在线巡视'
      //         },
      //         {
      //           childMenu: [],
      //           icon: '',
      //           iconImage: '',
      //           id: 'test-inspectionTourHistory',
      //           linkUrl: 'InspectionTourHistory',
      //           menuName: '巡视历史'
      //         }
      //       ],
      //       icon: '',
      //       iconImage: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/d58dcac0d62640fea45222649034086d.png',
      //       id: 'test-classroomInspectionTour',
      //       linkUrl: '',
      //       menuName: '教室巡视'
      //     }
      //   ],
      //   ...(res.rt || [])
      // ]
    },
    menuItemClick({ item, key }) {
      this.$router.push({ name: key })
      this.defaultSelectedKeys = [key]
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async getUserInfo() {
      try {
        let result = await this.$api.getUserInfo()
        if (!result) return this.$router.push({ name: 'Login' })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.userInfo = result.rt
        this.SetUserInfo(result.rt)
        this.getAdminUserSchool()
        this.disposeForMenuTree()
      } catch (err) {
        console.log(err)
      }
    },
    // 处理菜单的展示：
    // 目前运行概览页面发至外网不暴露：
    // 目前只针对运行概览页面：
    disposeForMenuTree() {
      const { isCheck } = this.userInfo
      const menuTreeCopy = JSON.parse(JSON.stringify(this.menuTree))
      // 获取运行概览页面：
      // let menuTreeOFTheOperationOverview = findItemForTree(menuTreeCopy, 'subs', 'key', 'OperationOverview')
      let menuTreeOFTheOperationOverview = findItemForTree(menuTreeCopy, 'childMenu', 'id', 'OperationOverview')
      // if (isCheck) {
      //   menuTreeOFTheOperationOverview.show = true
      // } else {
      //   menuTreeOFTheOperationOverview.show = false
      // }

      // 只有管理员才展示视频切片列表
      // if (this.userInfo.userType != 1) {
      //   menuTreeCopy[1].subs.splice(3, 1)
      //   // 管理员或者哈工程的人才可以看到数据大屏列表 100 预发/测试schoolId 506 线上哈工程schoolId
      //   if (this.userInfo.schoolId.indexOf('100') < 0 && this.userInfo.schoolId.indexOf('506') < 0) {
      //     menuTreeCopy[1].subs.splice(3, 2)
      //   }
      // }
      this.menuTree = menuTreeCopy
    },
    /**
     * @description: 更新管理学校机构列表选中状态
     * @param {*}
     * @return {*}
     */
    updateSchoolSelectStatus() {
      if (this.schoolSelectList.length != this.schoolList.length) {
        if (this.schoolSelectList.length == 0) {
          this.schoolIsSomeSelect = false
          this.schoolIsAllSelectStatus = false
        } else {
          this.schoolIsSomeSelect = true
          this.schoolIsAllSelectStatus = false
        }
      } else {
        if (this.schoolSelectList.length == 0) {
          this.schoolIsSomeSelect = false
          this.schoolIsAllSelectStatus = false
        } else {
          this.schoolIsSomeSelect = false
          this.schoolIsAllSelectStatus = true
        }
      }
    },
    deleteSchoolById(id) {
      let findIndex = this.currentSelectSchoolList.findIndex((item) => item.id == id)
      if (findIndex != -1) {
        this.currentSelectSchoolList.splice(findIndex, 1)
        if (this.schoolSubmitSelf.trim().length) {
          this.searchSchoolListBySelf()
        }
      }
      let selectIndex = this.schoolSelectList.findIndex((item) => item == id)
      if (selectIndex != -1) {
        this.schoolSelectList.splice(selectIndex, 1)
      }
      this.updateSchoolSelectStatus()
    },
    searchSchoolListBySelf() {
      this.currentSelectSchoolListBySelf =
        this.currentSelectSchoolList.filter((item) => {
          if (
            item.schoolName.indexOf(this.schoolSubmitSelf) != -1 ||
            item.province.indexOf(this.schoolSubmitSelf) != -1
          ) {
            return true
          } else {
            return false
          }
        }) || []
    },
    /**
     * @description: 更新省份全选信息
     * @param {*}
     * @return {*}
     */
    updateProvinceSelectStatus() {
      if (this.provinceSelectList.length != this.provinceCanSelectList.length) {
        if (this.provinceSelectList.length == 0) {
          this.provinceIsSomeSelect = false
          this.provinceIsAllSelectStatus = false
        } else {
          this.provinceIsSomeSelect = true
          this.provinceIsAllSelectStatus = false
        }
      } else {
        this.provinceIsSomeSelect = false
        this.provinceIsAllSelectStatus = true
      }
    },
    provinceIsAllSelect(e) {
      if (e.target.checked) {
        this.provinceIsAllSelectStatus = true
        this.provinceSelectList = this.provinceCanSelectList
      } else {
        this.provinceIsAllSelectStatus = false
        this.provinceSelectList = []
      }
      this.provinceIsSomeSelect = false
      if (this.provinceSelectList.length) {
        this.searchSchoolList()
      } else {
        this.schoolList = []
        this.currentSelectSchoolList = []
        this.schoolSelectList = []
        this.schoolIsAllSelectStatus = false
        this.schoolIsSomeSelect = false
      }
    },
    schoolIsAllSelect(e) {
      if (e.target.checked) {
        this.schoolSelectList = this.schoolList.map((item) => item.id)
        this.currentSelectSchoolList = this.schoolList
      } else {
        this.schoolSelectList = []
        this.currentSelectSchoolList = []
      }
      this.updateSchoolSelectStatus()
    },
    async searchSchoolList(isSelect = false, list = []) {
      let provinceIds = ''
      if (list.length) {
        provinceIds = list.join(',')
      } else {
        provinceIds = this.provinceSelectList.join(',')
      }
      let res = await this.$http.batchSchoolByProvinceId({
        provinceIds,
        schoolName: this.schoolSubmit
      })
      if (res.code !== 200) return this.$message.error(res.msg)
      this.schoolList = res.rt || []
      this.updateSchoolSelectStatus()
      if (isSelect) {
        this.schoolSelectList = this.currentSelectSchoolList.map((item) => item.id)
        this.updateSchoolSelectStatus()
      }
    },
    selectSchool(e, item) {
      if (this.schoolSelectList.includes(item.id)) {
        let schoolSet = new Set(this.schoolSelectList)
        schoolSet.delete(item.id)
        this.schoolSelectList = Array.from(schoolSet)
        let schoolItemIndex = this.currentSelectSchoolList.findIndex((item1) => item1.id == item.id)
        if (schoolItemIndex != -1) {
          this.currentSelectSchoolList.splice(schoolItemIndex, 1)
        }
      } else {
        this.schoolSelectList.push(item.id)
        let schoolItem = this.schoolList.find((item1) => item1.id == item.id)
        if (schoolItem) {
          this.currentSelectSchoolList.push(schoolItem)
        }
      }
      this.updateSchoolSelectStatus()
    },
    selectProvince(e, item) {
      if (this.provinceSelectList.includes(item.provinceId)) {
        let provinceSet = new Set(this.provinceSelectList)
        provinceSet.delete(item.provinceId)
        this.provinceSelectList = Array.from(provinceSet)
        // 取消省份选中 删除选中学校机构
        let schoolListT = this.currentSelectSchoolList.filter((item1) => item1.provinceId != item.provinceId) || []
        this.currentSelectSchoolList = schoolListT
        let schoolListT2 = (this.schoolList.filter((item1) => item1.provinceId == item.provinceId) || []).map(
          (item1) => item1.id
        )
        this.schoolSelectList = this.schoolSelectList.filter((item1) => !schoolListT2.includes(item1))
        this.updateSchoolSelectStatus()
      } else {
        this.provinceSelectList.push(item.provinceId)
      }
      if (this.provinceSelectList.length == 0) {
        this.schoolList = []
      } else {
        this.searchSchoolList()
      }
      this.updateProvinceSelectStatus()
    },
    async searchProvinceList() {
      let provinceList = await this.$http.getProvinceList({
        province: this.provinceSubmit
      })
      if (provinceList.code !== 200) return this.$message.error(provinceList.msg)
      this.provinceList = provinceList.rt || []
      this.provinceCanSelectList = (provinceList.rt || [])
        .filter((item) => item.schoolCount != 0)
        .map((item) => item.provinceId)
      let provinceTList = (provinceList.rt || []).map((item) => item.provinceId)
      this.searchSchoolList(false, provinceTList)
    },
    async userOperationItemClick({ operationType }) {
      switch (operationType) {
        case 0:
          let provinceList = await this.$http.getProvinceList()
          if (provinceList.code !== 200) return this.$message.error(provinceList.msg)
          this.provinceList = provinceList.rt || []
          this.provinceCanSelectList = (provinceList.rt || [])
            .filter((item) => item.schoolCount != 0)
            .map((item) => item.provinceId)
          this.selectedRowKeys = []
          let result = await this.$http.getAdminUserSchool()
          if (result.code !== 200) return this.$message.error(result.msg)
          let schoolRes = await this.$http.getSelectSchoolList()
          if (schoolRes.rt.resultStatus == -1 || schoolRes.code != 200) {
            return this.$message.error(schoolRes.rt.resultMessage || '获取学校数据失败!')
          }
          this.adminUserSchoolList = (result.rt || []).map((item) => {
            item.key = item.id || 0
            return item
          })
          schoolRes.rt?.forEach((item) => {
            this.selectedRowKeys.push(item.id)
          })
          this.currentSelectSchoolList = schoolRes.rt || []
          let selectProvinceList = schoolRes.rt?.map((item) => item.provinceId) || []
          this.provinceSelectList = Array.from(new Set(selectProvinceList)).map((item) => Number(item))
          this.updateProvinceSelectStatus()
          this.searchSchoolList(true)
          this.dialogFlag = true
          break
        case 1:
          // 退出需要调接口：
          await this.$http.adminLogout()
          this.Mutation_REMOVE_TOKEN()
          this.$message.success('退出成功')
          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 500)
          break
      }
    },
    hideMask() {
      this.dialogFlag = false
    },
    async operationForConfirm() {
      try {
        if (!this.schoolSelectList.length) return this.$message.error('请选择机构')
        let params = {
          schoolId: this.schoolSelectList.join(',')
        }
        let result = await this.$http.switchSchool(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('机构切换成功，即将更新')
        setTimeout(() => {
          let newToken = result.rt
          this.Mutation_SET_TOKEN(newToken)
          window.location.reload()
        }, 500)
      } catch (err) {
        console.log(err)
      }
      this.hideMask()
    },
    async getAdminUserSchool() {
      try {
        const result = await this.$http.getAdminUserSchool()
        this.adminUserSchoolList = result.rt || []
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss">
// 20220511 add：
.ant-popover-inner-content {
  padding: 0;
}
</style>

<style lang="scss" scoped>
::v-deep .ant-layout {
  background: #f6f8fa;
}
::v-deep .ant-menu-item,
::v-deep .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
#components-layout-demo-custom-trigger {
  // width: 100vw;
  width: 100%;
  height: 100vh;
  // old logo:
  // .logo {
  //     height: 60px;
  //     padding: 10px;
  //     transition: width 0.2s;
  //     .logo_inner {
  //         width: 100%;
  //         height: 100%;
  //         display: flex;
  //         overflow: hidden;
  //         cursor: pointer;
  //         img {
  //             width: 100%;
  //             transition: transform 0.2s;
  //             &:hover {
  //                 transform: scale(1.1);
  //             }
  //         }
  //     }
  // }
  .new_logo {
    width: 100%;
    height: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 48px;
      display: block;
      cursor: pointer;
    }
  }
  // 菜单栏样式：
  ::v-deep.ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: #5f60d3 !important;
    box-shadow: none;
  }
  ::v-deep .ant-menu.ant-menu-dark .ant-menu-item-selected,
  .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
    background-color: rgba(255, 255, 255, 0.2);
    border-right: 4px solid #fff;
  }
  .layout_header_container {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    box-shadow: 0 0 10px #ddd;
    // .operation_for_close_or_open {
    //     width: 64px;
    //     height: 64px;
    //     line-height: 68px;
    //     text-align: center;
    //     color: #FFF;
    //     .trigger {
    //         font-size: 18px;
    //         line-height: 64px;
    //         cursor: pointer;
    //         transition: color 0.3s;
    //     }
    //     .trigger:hover {
    //         color: #1890ff;
    //     }
    // }
    // .breadcrumb_container {
    //     width: auto;
    //     height: 64px;
    //     padding: 0 10px;
    //     padding-left: 0;
    //     display: flex;
    //     align-items: center;
    //     position: absolute;
    //     left: 64px;
    //     top: 0;
    //     ::v-deep.ant-breadcrumb-link {
    //         color: #FFF;
    //     }
    //     ::v-deep.ant-breadcrumb-separator {
    //         color: #FFF;
    //     }
    // }
    .welcome_text {
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      color: #041633;
      padding-left: 16px;
      display: flex;
      align-items: center;
    }
    .header_right_module {
      width: auto;
      height: 56px;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
    }
    .org_name_from_some_max_for_three {
      width: auto;
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      color: #9ca5b1;
    }
    .messsage_icon {
      width: auto;
      height: 56px;
      padding: 0 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 25px;
      img {
        width: 20px;
        height: 20px;
        display: block;
      }
    }
    .operation_of_user_container {
      width: auto;
      height: 56px;
      padding: 0 20px;
      padding-left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .operation_of_user_container_inner_img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: 0 0 2px #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img {
          width: 100%;
          transition: transform 0.2s ease-in;
          &:hover {
            transform: scale(1.03);
          }
        }
      }
      // .operation_of_user_container_inner_text {
      //   max-width: 140px;
      //   padding: 0 10px;
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      //   &:hover {
      //     text-shadow: 1px 1px 20px #ddd;
      //   }
      // }
      .operation_of_user_container_inner_icon {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
}
.user_operation_list {
  .user_operation_item_first {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
  }
  .user_operation_item {
    width: 100%;
    height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    transition: all 0.3s;
    padding: 0 16px;
    &:hover {
      background-color: #eff3f7;
    }
    &:active {
      background-color: #fff;
    }
  }
  .user_operation_item_icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
@keyframes breadcrumbMove {
  from {
    left: 150px;
    opacity: 0;
  }
  to {
    left: 64px;
    opacity: 1;
  }
}
.breadcrumb_move_class_name {
  animation: breadcrumbMove 0.5s 0s ease;
}
// 自定义菜单颜色：
// ::v-deep.ant-layout-sider {
//     background: #1E2C5C;
// }
// ::v-deep.ant-menu-dark .ant-menu-inline.ant-menu-sub {
//     background: #0d1733;
//     // box-shadow: 0 2px 8px rgb(0 0 0 / 45%) inset;
// }
// ::v-deep.ant-menu-dark, .ant-menu-dark .ant-menu-sub {
//     background: #1E2C5C;
// }
// ::v-deep.ant-menu.ant-menu-dark .ant-menu-item-selected {
//     background-color: #EBF7EF;
//     color: #3DB166;
//     font-weight: bold;
//     border-left: 6px solid #3DB166;
// }
// ::v-deep.ant-menu-dark .ant-menu-item-selected .anticon,
// ::v-deep.ant-menu-dark .ant-menu-item-selected .anticon + span {
//     color: #3DB166;
// }
// ::v-deep.ant-menu.ant-menu-dark .ant-menu-item-selected {
//     background-color: #3DB166;
// }
// choose org:
@mixin dialogTitle($color) {
  width: 100%;
  height: 25px;
  font-weight: bold;
  color: $color;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.switching_mechanism {
  .lists {
    display: flex;
    .right_arrow {
      margin-left: 12px;
      display: flex;
      align-items: center;
    }
    .list_item {
      border-radius: 4px;
      border: 1px solid #f6f8fa;
      width: 240px;
      height: 472px;
      .list_header {
        display: flex;
        justify-content: space-between;
        padding: 11px 12px;
        background: #f6f8fa;
        > span {
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #9ca5b1;
        }
        > span:nth-child(1) {
          font-size: 14px;
          font-family:
            PingFangSC-Medium,
            PingFang SC;
          font-weight: 500;
          color: #041633;
        }
        ::v-deep.ant-checkbox-wrapper {
          > span:nth-child(2) {
            font-size: 14px;
            font-family:
              PingFangSC-Medium,
              PingFang SC;
            font-weight: 500;
            color: #041633;
          }
        }
        ::v-deep.ant-checkbox-checked {
          .ant-checkbox-inner {
            background-color: #5f60d3;
            border-color: transparent;
          }
        }
        ::v-deep.ant-checkbox-indeterminate {
          .ant-checkbox-inner {
            &::after {
              background-color: #5f60d3;
            }
          }
        }
      }
      .list_search {
        border-bottom: 1px solid #f6f8fa;
        > span {
          width: 223px;
          margin-top: 8px;
          margin-bottom: 8px;
          ::v-deep.ant-input {
            border-radius: 19px !important;
            border: 1px solid #e3e8ec;
          }
          padding: 0 8px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .item_body {
        text-align: left;
        height: 380px;
        overflow-y: scroll;
        > div {
          padding: 11px 12px;
          ::v-deep.ant-checkbox-checked {
            .ant-checkbox-inner {
              background-color: #5f60d3;
              border-color: transparent;
            }
          }
        }
      }
      .select_item_body {
        font-size: 14px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #041633;
        > div {
          display: flex;
          justify-content: space-between;
          img {
            width: 16px;
            height: 16px;
            margin-top: 3px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bottom_btn {
    text-align: center;
    margin-top: 16px;
    button {
      width: 152px;
      height: 44px;
      background: #5f60d3;
      border-radius: 8px;
      font-size: 16px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.dialog_inner_container {
  text-align: left;
  .dialog_inner_container_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_body {
    width: 100%;
    height: 500px;
    padding: 15px 10px;
    overflow: auto;
    .org_list {
      border: 1px solid #f5f5f5;
      .org_item {
        display: flex;
        padding: 10px 0;
        border-bottom: 1px solid #f5f5f5;
        box-shadow: 0 0 10px #eee;
        &:nth-last-child(1) {
          border-bottom: none;
        }
        &.org_item_header {
          background-color: #1890ff;
          color: #fff;
          padding: 15px 0;
        }
        .header_text {
          font-weight: bold;
        }
        .org_item_inner_checkbox {
          flex: 1;
          @include verticalAndCrosswiseCenter();
          .operation_for_checkbox {
            cursor: pointer;
            font-size: 20px;
            &:hover {
              text-shadow: 0 0 10px #ddd;
            }
            &.active {
              color: #1890ff;
            }
          }
        }
        .org_item_inner_identification {
          flex: 2;
          @include verticalAndCrosswiseCenter();
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }
        .org_item_inner_name {
          flex: 3;
          @include verticalAndCrosswiseCenter();
        }
      }
    }
  }
  .dialog_inner_container_footer {
    padding: 10px 0;
    @include verticalAndCrosswiseCenter();
    .operation_for_confirm {
      width: 120px;
      height: 40px;
      background-color: #1890ff;
      color: #fff;
      @include verticalAndCrosswiseCenter();
      cursor: pointer;
      border-radius: 10px;
      user-select: none;
      &:hover {
        background-color: #146cbd;
      }
      &:active {
        background-color: #74a6d5;
      }
    }
  }
}
.a_sub_menu_title_icon_for_img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
// ::v-deep.ant-menu-submenu-inline
//   > .ant-menu-submenu-title
//   .ant-menu-submenu-arrow {
//   width: 33px;
// }
</style>
